// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"bc46e389","455":"f2324954"}[chunkId] + ".chunk.js";
};